import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sdPhone',
  standalone: true,
})
export class PhonePipe implements PipeTransform {
  transform(input: string | null | undefined): string {
    if (input === null || input === undefined) return '';
    let formattedNumber = input;

    const c = input[0] === '1' ? '1 ' : '';
    input = input[0] === '1' ? input.slice(1) : input;

    // # (###) ###-#### as c (area) front-end
    const area = input.substring(0, 3);
    const front = input.substring(3, 6);
    const end = input.substring(6, 10);

    if (front) {
      formattedNumber = c + '(' + area + ') ' + front;
    }
    if (end) {
      formattedNumber += '-' + end;
    }
    return formattedNumber;
  }
}
